import { Module, Action, getModule, Mutation, VuexModule } from 'vuex-module-decorators'
import { ApiAgent } from '@/plugins/ApiRequest'
import store from '@/store'
import { sessionStore } from '@/store/session/SessionStoreModule'
import * as ApiPath from '@/tcw/constant/ApiPath'
import Getsudo from '@/tcw/domain/Getsudo'
import { ApiGeneralObjectArrayPayload } from '@/tcw/api/types'
import * as tcw from '@/tcw/utils/TcwService'
import { ShouninTask } from '../types'

/**
 * メッセージSTORE
 */
@Module({
  name: 'ShouninTaskStoreModule',
  store,
  namespaced: true,
  dynamic: true
})
export default class ShouninTaskStoreModule extends VuexModule {
  private shouninTaskList: ShouninTask[] = []

  /****************
   * Mutation
   ****************/
  @Mutation
  private setShouninTaskList(shouninTaskList: ShouninTask[]) {
    this.shouninTaskList = shouninTaskList
  }

  /****************
   * Getter
   ****************/
  public get has(): boolean {
    return this.shouninTaskList.length > 0
  }
  public get get(): ShouninTask[] {
    return this.shouninTaskList
  }
  public get count(): number {
    return this.shouninTaskList.length
  }

  /****************
   * Action
   ****************/
  /**
   * 新規データ作成
   */
  @Action({ rawError: true })
  public set(shouninTaskList: ShouninTask[]): void {
    this.setShouninTaskList(shouninTaskList)
  }
  /**
   */
  @Action({ rawError: true })
  public clear(): void {
    this.setShouninTaskList([])
  }
  /**
   */
  @Action({ rawError: true })
  public async fetch(): Promise<ShouninTask[]> {
    try {
      const apiAgent = ApiAgent.create(tcw.getApiUrlBase(), sessionStore.sessionToken)
      const response: ApiGeneralObjectArrayPayload = await apiAgent.call<
        ApiGeneralObjectArrayPayload
      >(ApiPath.Paths.ShouninList.get, 'GET')

      const shouninTasks: ShouninTask[] = response.map(task => {
        const getsudoDate = tcw.dateOf(task.getsudo as string)
        return (Object.assign({}, task, {
          getsudo: getsudoDate
            ? Getsudo.of(getsudoDate.getFullYear(), getsudoDate.getMonth() + 1)
            : null
        }) as unknown) as ShouninTask
      })
      this.setShouninTaskList(shouninTasks)

      return shouninTasks
    } catch (e) {
      return Promise.reject(e)
    }
  }
}

export const shouninTaskStore = getModule(ShouninTaskStoreModule)
